import { createMuiTheme } from "@material-ui/core/styles";

export const brand = {
  amber: "#F5A623",
  amberDeep: "#C8841A",
  amberDark: "#1A1205",
  amberLight: "#FFF3D6",
  amberFaint: "#FFFBF2",
  surface: "#F7F4EF",
  white: "#FFFFFF",
  text: "#1A1205",
  textSec: "#7A6E5F",
  textDis: "#C0B4A4",
  sep: "rgba(26,18,5,0.09)",
  error: "#D04040",
  errorBg: "#FFF0F0",
  warn: "#1A6BC8",
  warnBg: "#E8F1FC",
  success: "#2D9A6A",
} as const;

export const ratingColors = ["#2D9A6A", "#F5A623", "#E8741A", "#D04040"] as const;

const theme = createMuiTheme({
  palette: {
    primary: { main: brand.amber, dark: brand.amberDeep, contrastText: brand.amberDark },
    secondary: { main: brand.amberDark, contrastText: brand.amber },
    error: { main: brand.error },
    background: { default: brand.surface, paper: brand.white },
    text: { primary: brand.text, secondary: brand.textSec, disabled: brand.textDis },
    divider: brand.sep,
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily:
      '"DM Sans", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  },
});

export default theme;
